var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "manuscript-list" }, [
    _c(
      "ul",
      { staticClass: "manuscript-list__items" },
      _vm._l(_vm.manuscripts, function (manuscript) {
        return _c(
          "li",
          {
            key: manuscript.manuscriptKey,
            staticClass: "manuscript-list__item",
            class: {
              "manuscript-list__item--active":
                manuscript.manuscriptKey === _vm.activeManuscriptKey,
            },
          },
          [
            _c(
              "button",
              {
                staticClass: "manuscript-list__item-button",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _setup.onClickManuscript(manuscript.manuscriptKey)
                  },
                },
              },
              [
                _c("span", { staticClass: "manuscript-list__item-title" }, [
                  _vm._v(_vm._s(manuscript.title)),
                ]),
                (manuscript.issueCount ?? 0) > 0
                  ? _c("span", { staticClass: "manuscript-list__item-badge" }, [
                      _vm._v(" " + _vm._s(manuscript.issueCount) + " "),
                    ])
                  : _vm._e(),
              ]
            ),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }